import React from 'react';

import { dashboardCustomsInstructionApis } from '@apis/next/customsInstructionApis';
import { Button } from '@components/Button';
import { useFormUtils } from '@hooks/useFormUtils';
import {
  InstructionType,
  InstructionChangeRequiredForm as InstructionChangeRequiredFormT,
} from '@models/next/Instruction';
import { useForm } from '@monoid-dev/mobx-zod-form-react';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import { formStrings } from '@utils/forms';
import { observer } from 'mobx-react';

const useStyles = makeMuiStyles((theme, common) => ({
  instructionChangeRequiredFormContent: {
    ...common.flexColumn,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: 10,
  },
  instructionChangeRequiredFormTextarea: {
    height: 160,
    border: 'none',
    outline: 'none',
    resize: 'vertical',
  },
  instructionChangeRequiredFormActions: {
    ...common.flexInline,
    ...common.justifyEnd,
    marginTop: 10,
    columnGap: 10,
  },
}));

export interface InstructionChangeRequiredFormProps {
  type: InstructionType;
  onClose: () => void;
  onSuccess: () => void;
  d2dNo: string;
}

export const InstructionChangeRequiredForm: React.FC<InstructionChangeRequiredFormProps> = observer(
  (props) => {
    const { d2dNo, onClose, onSuccess } = props;

    const classes = {
      ...useCommonStyles(),
      ...useStyles(),
    };

    const patchDashboardCustomsInstruction = dashboardCustomsInstructionApis.usePatch(
      '/dashboard/customs-instruction/:d2d_no',
      {
        params: {
          d2d_no: d2dNo,
        },
      },
      {
        onSuccess,
      },
    );

    const { renderAlerts } = useFormUtils({
      mutations: [patchDashboardCustomsInstruction],
    });

    const form = useForm(InstructionChangeRequiredFormT);

    const { fields } = form.root;

    return (
      <div className={classes.instructionChangeRequiredFormContent}>
        {renderAlerts()}

        <textarea
          disabled={patchDashboardCustomsInstruction.isLoading}
          className={classes.instructionChangeRequiredFormTextarea}
          {...form.bindTextArea(fields.message)}
        />

        <div className={classes.instructionChangeRequiredFormActions}>
          <Button
            color="outlined"
            text={formStrings.cancel}
            size="smaller"
            type="button"
            onClick={onClose}
          />
          <Button
            color="primary"
            text={formStrings.submit}
            size="smaller"
            type="button"
            isLoading={patchDashboardCustomsInstruction.isLoading}
            onClick={async () => {
              await form.handleSubmit(async () => {
                if (form.parsed.success) {
                  await patchDashboardCustomsInstruction.mutateAsync({
                    ...form.parsed.data,
                    status_name: '修正依頼済',
                  });
                }
              });
            }}
          />
        </div>
      </div>
    );
  },
);
